<template>
  <div id="page-dialogs" >
    <div>
      <v-breadcrumbs :items="breadcrumbs" >
        <v-icon slot="divider" >forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg6>
           <base-material-card
          color="primary"
          icon="library_books"
          title="Cambiar Contraseña"
          class="elevation-1 px-5 py-3"
        >
            
            <v-card-text>
              <v-form>
                <v-container grid-list-md text-xs-center @keyup.enter="actualizar()" >
                <v-text-field
                  :append-icon="iconpass1"
                  @click:append="mostrarPass1"
                  :rules="[rules.required]"
                  name="login"
                  label="Contrseña Anterior"
                  :type="passwordFieldType1"
                  v-model="model.pass_old"
                ></v-text-field>
                <v-text-field
                  :append-icon="iconpass2"
                  @click:append="mostrarPass2"
                  :rules="[rules.required]"
                  name="login"
                  label="Ingresar Nueva Contrseña"
                  :type="passwordFieldType2"
                  v-model="model.pass_new"
                ></v-text-field>
                <v-text-field
                  :append-icon="iconpass3"
                  :rules="[rules.required]"
                  @click:append="mostrarPass3"
                  name="password"
                  label="Confirmar Nueva Contraseña"
                  :type="passwordFieldType3"
                  v-model="model.pass_confirm"
                ></v-text-field>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-chip
                v-if="model.pass_confirm != model.pass_new"
                outlined
                color="red"
                ><v-icon color="red" > error</v-icon>Contraseñas no
                coinciden..</v-chip
              >
              <v-spacer></v-spacer>
              <v-btn
                block
                color="primary"
                v-bind:disabled="
                  model.pass_confirm === '' ||
                    model.pass_confirm != model.pass_new
                "
                @click="actualizar"
                :loading="loading"
                >Actualizar</v-btn
              >
            </v-card-actions>
                        </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({ fab: false,
    breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Cambiar Contraseña",
        disabled: true,
        href: ""
      }
    ],
    loading: false,
    passwordFieldType1: "password",
    passwordFieldType2: "password",
    passwordFieldType3: "password",
    iconpass1: "fa-eye",
    iconpass2: "fa-eye",
    iconpass3: "fa-eye",
    rules: {
      required: value => !!value || "El campo no puede ir vacio"
    },
    model: {
      pass_old: "",
      pass_new: "",
      pass_confirm: ""
    }
  }),

  methods: {
    mostrarPass1: function(evt) {
      this.passwordFieldType1 =
        this.passwordFieldType1 === "password" ? "text" : "password";
      this.iconpass1 =
        this.passwordFieldType1 === "password" ? "fa-eye" : "fa-eye-slash";
    },
    mostrarPass2: function(evt) {
      this.passwordFieldType2 =
        this.passwordFieldType2 === "password" ? "text" : "password";
      this.iconpass2 =
        this.passwordFieldType2 === "password" ? "fa-eye" : "fa-eye-slash";
    },
    mostrarPass3: function(evt) {
      this.passwordFieldType3 =
        this.passwordFieldType3 === "password" ? "text" : "password";
      this.iconpass3 =
        this.passwordFieldType3 === "password" ? "fa-eye" : "fa-eye-slash";
    },
    actualizar() {
      var data = {
        usuario: this.$local_storage.get("id_usuario"),
        password: this.model.pass_old,
        password_nuevo: this.model.pass_new,
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache"
        }
      };

      var url = this.$hostname + "usuarios/change_password/";

      var self = this;
      axios
        .put(url, data)
        .then(function(response) {
          self.$swal({
            type: "success",
            title: "Operación Existosa",
            text: response.data.mensaje,
            footer: ""
          });
         // self.$router.push("/home").catch(()=>{});
        })
        .catch(function(error) {
          var msg = "";
          if (error.response.data.mensaje) {
            msg = error.response.data.mensaje;
          }
          if (error.response.data.usuario) {
            msg = error.response.data.usuario[0];
          }
          if (error.response.data.password) {
            msg = error.response.data.password[0];
          }
          if (error.response.data.solicitud) {
            msg = error.response.data.solicitud[0];
          }
          self.$swal({
            type: "error",
            title: "Datos no Válidos",
            text: msg,
            footer: ""
          });
        });
      // this.$router.push('/pass');
    }
  }
};
</script>
<style scoped lang="css" >
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
